export default {
    priceCheck(context){
        //価格初期化
        context.commit('updatePriceData', {name:'price', value:0})
        context.commit('updatePriceData', {name:'price_ura', value:0})
        context.commit('updatePriceData', {name:'price_add', value:0})
        //console.log('priceCheck',context.state.price_data.price_file)
        if(
            context.state.step1_data.item_number === '' ||
            typeof(context.state.xlsx_data.item_data) === 'undefined' ||
            typeof(context.state.xlsx_data.item_data['SH'+context.state.step1_data.item_number]) === 'undefined'
        ) {
            return false
        }
        const path = './item_data/price_data/'
        context.dispatch('getFileName')
        const file = context.state.price_data.check_file
        if(file === ''){return false}
        //同じ基本価格は読まない
        if(file != context.state.price_data.price_file){
            context.commit('updatePriceData', {name:'price_file', value:file})
            const req = new XMLHttpRequest()
            req.open('GET', path+file, true)
            req.responseType = 'text'
            const scope = context

            //ローディングをつける　TODO
            req.onload = function () {
                //console.log('ファイル読み込み成功',req.responseText)
                if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                    //console.log('ファイル読み込みエラー')
                    context.commit('updateErrorMessage', 'ファイル読み込みエラー')
                    return false
                }
                context.commit('updateErrorMessage', '')
                const data = req.response
                //データを処理
                context.dispatch('csvFormating', data)
            }
            req.onerror = function() {
                //console.log('ファイル読み込みエラー')
                context.commit('updateErrorMessage', 'ファイル読み込みエラー')
                return false
            }
            req.send();
        }else{
            context.dispatch('priceCalculation')
        }
    },
    /**
     * ファイル名取得　※重要ここで取得ファイルを決める
     */
    getFileName(context){
        let item_number = context.state.step1_data.item_number
        let style_selected1_name = context.state.step2_data.style_selected1_name
        let style_selected2_name = context.state.step2_data.style_selected2_name
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        const search_data = context.state.search_data
        const file_rule = context.state.xlsx_data.file_rule
        if (0 === Object.keys(search_data).length) {return false}
        context.commit('updatePriceData', {name:'price_item_number', value:item_number})
        //価格は先頭品番のみ

        if(context.state.xlsx_data.item_data['SH'+item_number]['先頭'] !=='*'){
            for(let j=1; j<50; j++){
                if(context.state.xlsx_data.item_data['SH'+(parseInt(item_number)-j)]['先頭'] ==='*'){
                    item_number = parseInt(item_number)-j
                    context.commit('updatePriceData', {name:'price_item_number', value:item_number})
                    break
                }
            }
        }

        //加算ファイル
        if(style_selected1_name === 'マルチカバー2サイドデコ'){
            style_selected1_name = 'マルチカバー'
        }
        if(group1_1 ==='クッション' && style_selected1_name !== 'クッションマチ付き'){
            style_selected1_name = 'クッション'
        }

        //ファイルルールを回す
        let pre_hit_count = 0
        for(let i=0; i<file_rule.length; i++){
            let hit_count = 0
            let condition_count = 0
            for(let key in file_rule[i]){
                if(file_rule[i][key] != '' && key != '計算式記号'){
                    condition_count++
                }
            }
            //一致しない場合は逆に
            if(file_rule[i].group1 && file_rule[i].group1 && style_selected1_name && file_rule[i].group1 && file_rule[i].group1!==style_selected1_name){
                continue
            }
            if(file_rule[i].group2 && file_rule[i].group2 && style_selected2_name && file_rule[i].group2 && file_rule[i].group2!==style_selected2_name){
                continue
            }

            if(file_rule[i].group1 && file_rule[i].group1 && style_selected1_name && file_rule[i].group1 && file_rule[i].group1===style_selected1_name){
                hit_count++
            }
            if(file_rule[i].group2 && file_rule[i].group2 && style_selected2_name &&file_rule[i].group2 && file_rule[i].group2===style_selected2_name){
                hit_count++
            }

            if(file_rule[i]['裾形状を選ぶ↓ヨコ使いレース生地のみ'] && file_rule[i]['裾形状を選ぶ↓ヨコ使いレース生地のみ']===context.state.step3_data.suso){
                hit_count++
            }
            if(file_rule[i]['絵羽'] && file_rule[i]['絵羽']===search_data['絵羽']){
                hit_count++
            }
            if(file_rule[i]['メカを選ぶ'] && file_rule[i]['メカを選ぶ']===context.state.step3_data.mecha){
                hit_count++
            }
            if(file_rule[i]['仕様を選択する'] && file_rule[i]['仕様を選択する']===context.state.step3_data.kurumi){
                hit_count++
            }
            if(file_rule[i]['ドレープ/レース'] && file_rule[i]['ドレープ/レース']===search_data['ドレープ/レース']){
                hit_count++
            }
            if(file_rule[i]['ヨコ使い'] && file_rule[i]['ヨコ使い']===search_data['ヨコ使い']){
                hit_count++
            }
            if(file_rule[i]['縫い区分'] && file_rule[i]['縫い区分']===search_data['縫い区分']){
                hit_count++
            }
            if(file_rule[i]['デザインビュー'] && file_rule[i]['デザインビュー']===search_data['デザインビュー']){
                hit_count++
            }
            if(file_rule[i]['FW付（filo縫製）'] && file_rule[i]['FW付（filo縫製）']===search_data['FW付（filo縫製）']){
                hit_count++
            }
            // console.log('i=' + i + ' group1=' + file_rule[i].group1 + ' group2=' + file_rule[i].group2 + ' condition=' + condition_count + ' hit=' + hit_count+' pre_hit_count='+pre_hit_count)
            if(hit_count >= condition_count && hit_count>pre_hit_count){
                pre_hit_count = hit_count
                let file_name = item_number+file_rule[i]['計算式記号']+'.CSV'
                if(context.state.step3_data.height_size > 310 && (file_rule[i]['計算式記号'] === 'SWH' || file_rule[i]['計算式記号'] === 'SWS' || file_rule[i]['計算式記号'] === 'SWHL')){
                    file_name = item_number+file_rule[i]['計算式記号']+'-O.CSV'
                }
                // console.log('file_name', file_name)
                context.commit('updatePriceData', {name:'check_file', value:file_name})
            }
        }
    },
    /**
     * CSVフォーマット
     */
    csvFormating(context, payload){
        // 行単位で配列にする
        const lineArr = payload.split("\n")
        // 行と列の二次元配列にする
        let itemArr = []
        let csv_table = '<table class="price_list">'
        for (let i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split('","')
            if(itemArr[i].length===1){
                continue
            }
            csv_table += '<tr>'
            for(let j=0; j < itemArr[i].length; j++){
                itemArr[i][j] = itemArr[i][j].replace(/\r/g , '')
                itemArr[i][j] = itemArr[i][j].replace(/"/g , '')
                itemArr[i][j] = itemArr[i][j].replace(/,/g , '')
                csv_table += '<td>'+itemArr[i][j]+'</td>'
            }
            csv_table += '</tr>'
        }
        csv_table += '</table>'
        context.commit('updatePriceData', {name:'price_load_data', value:csv_table})

        const style_selected1_name = context.state.step2_data.style_selected1_name
        const style_selected2_name = context.state.step2_data.style_selected2_name
        const search_data = context.state.search_data
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        let group2 = ''
        let group2_1 = ''
        if(context.state.step2_data.style_selected2_id !== ''){
            group2 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group2
            group2_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group1
        }
        let yokotsukai = ''
        if(context.state.xlsx_data.item_data && context.state.price_data.price_item_number){
            yokotsukai = context.state.xlsx_data.item_data['SH' + context.state.price_data.price_item_number]['ヨコ使い']
        }
        let price_data = {}
        let w,ws,we,wid,h,hs,he,hid
        let setting_index = {}

        //カーテン
        if(group1_1 === 'カーテン') {
            if (yokotsukai === '○') {
                setting_index = {
                    '2倍ヒダ': {'片開き': 0, '両開き': 1,}
                }
            } else{
                setting_index = {
                    '2倍ヒダ': {'片開き': 0, '両開き': 2,}
                }
            }

            let is_flat = false
            for (let i = 0; i < itemArr.length - 1; i++) {
                if (itemArr[i][0] === '1.5倍ヒダ' || itemArr[i][0] === '2.5倍ヒダ' || itemArr[i][0] === 'フラット') {
                    setting_index[itemArr[i][0]] = {}
                    setting_index[itemArr[i][0]]['片開き'] = i
                    setting_index[itemArr[i][0]]['両開き'] = i + 1
                    if(itemArr[i][0] === 'フラット'){
                        is_flat = true
                    }
                }else if(i>2 && itemArr[i][0] === '' && !is_flat){
                    setting_index['フラット'] = {}
                    setting_index['フラット']['片開き'] = i
                    setting_index['フラット']['両開き'] = i + 1
                    is_flat = true
                }else if(i>2 && itemArr[i][0] === '' && is_flat){
                    setting_index['2.5倍ヒダ'] = {}
                    setting_index['2.5倍ヒダ']['片開き'] = i
                    setting_index['2.5倍ヒダ']['両開き'] = i + 1
                }
            }
        }else{
            for (let i = 0; i < itemArr.length - 1; i++) {
                if (itemArr[i][0] === '仕上り巾(cm)') {
                    setting_index['フラット'] = {}
                    setting_index['フラット']['片開き'] = i
                    break
                }
            }
        }

        let size_min_max = {}
        let id_size = {}

        for(let hida in setting_index){
            price_data[hida] = {}
            size_min_max[hida] = {}
            id_size[hida] = {}
            for(let open in setting_index[hida]){
                price_data[hida][open] =[]
                size_min_max[hida][open] = {}
                id_size[hida][open] = {}
                id_size[hida][open]['wid'] = []
                id_size[hida][open]['hid'] = []
                //各ヒダの巾情報位置
                let index = setting_index[hida][open]
                let height_min = ''
                let height_max = ''
                let width_min = ''
                let width_max = ''
                hid = 0
                for(let i=0; i<itemArr.length-1; i++){
                    if (!itemArr[i][0].match(/〜/)) {
                        continue
                    }
                    h = itemArr[i][0].split('〜')
                    hs = h[0]
                    he = h[1]
                    hid++
                    if(parseInt(h[0])===0 && parseInt(h[1])===0){
                        continue
                    }
                    id_size[hida][open]['hid'][hid] = {hs : hs, he : he}
                    if(height_min==='' && hs !=='' && !isNaN(hs)){
                        height_min = parseInt(hs)
                    }
                    height_max = parseInt(he)
                    wid = 0
                    for(let j=1; j < itemArr[i].length; j++){
                        if (!itemArr[index][j].match(/〜/)) {
                            continue
                        }
                        w = itemArr[index][j].split('〜')
                        ws = w[0]
                        we = w[1]
                        wid++
                        if(parseInt(w[0])===0 && parseInt(w[1])===0){
                            continue
                        }
                        id_size[hida][open]['wid'][wid] = {ws:ws, we:we}
                        if(width_min==='' && ws !== ''){
                            if (style_selected2_name === 'クロスオーバーフリル') {
                                ws = 50
                            } else if(group2 === 'スカラップスタイル' && yokotsukai !== '○'){
                                ws = 41
                            }
                            width_min = parseInt(ws)
                        }
                        width_max = parseInt(we)
                        //価格表()の価格は高さが200cmまで
                        if (itemArr[i][j].match(/\(/)) {
                            itemArr[i][j] = itemArr[i][j].replace(/\(/g , '')
                            itemArr[i][j] = itemArr[i][j].replace(/\)/g , '')
                            if(style_selected2_name.match(/シェード/)){
                                price_data[hida][open].push(
                                    {
                                        ws:ws,
                                        we:we,
                                        wid:wid,
                                        hs:hs,
                                        he:200,
                                        hid:hid,
                                        price:itemArr[i][j]
                                    }
                                )
                                //id_size['hid'][hid] = {hs : hs, he : 200}
                                continue
                            }
                        }
                        else if(itemArr[i][j]==='−'){
                            continue
                        }

                        price_data[hida][open].push({
                                ws:ws,
                                we:we,
                                wid:wid,
                                hs:hs,
                                he:he,
                                hid:hid,
                                price:itemArr[i][j]
                            })
                    }
                }
                if(style_selected1_name==='スペシャルスワッグ'){
                    height_min = 40
                }
                size_min_max[hida][open] = {width_min:width_min, height_min:height_min, width_max:width_max, height_max:height_max}
            }
        }
        context.commit('updateOptionSelected', {name: 'size_min_max', value: size_min_max, no_check: true})
        context.commit('updateOptionSelected', {name: 'id_size', value: id_size, no_check: true})
        context.commit('updatePriceData', {name:'price_csv', value:price_data})
        context.dispatch('priceCalculation')
    },
    /**
     * 基本生地計算
     */
    priceCalculation(context){
        if(context.state.price_data.price_file ===''){return false}
        if(context.state.price_data.price_csv === '') {return false}
        //カーテン
        let price = 0
        let hida = context.state.step3_data.hida
        let open = context.state.step3_data.open
        let width_size = context.state.step3_data.width_size
        let height_size = context.state.step3_data.height_size
        let set_number = context.state.step4_data.set_number
        const style_selected1_name = context.state.step2_data.style_selected1_name
        const style_selected2_name = context.state.step2_data.style_selected2_name
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        let group2_1 = ''
        if(context.state.step2_data.style_selected2_id !== ''){
            group2_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group1
        }

        //console.log('set_number='+set_number+' hida='+hida+' open='+open+' width='+width_size+' height='+height_size)
        //if(hida === null || open=== null || width_size === null || height_size==null){return false}
        if(hida === '' || open === '' || width_size === '' || height_size === ''){return false}
        if(hida === undefined){return false}
        //console.log('priceCalculation',set_number+': typeof='+typeof(set_number))
        if(!set_number){ set_number=0 }
        hida = hida.split('/')[0]
        hida = hida.replace(/約/g,'')
        if(hida==='1倍'){
            hida = 'フラット'
        }
        else if(hida==='2.3倍'){
            hida = '2倍ヒダ'
        }
        else{
            hida = hida+'ヒダ'
        }

        //開閉不可対策
        if(open === '開閉不可'){
            open='片開き';
        }

        if(
            typeof(context.state.price_data.price_csv) ==='undefined' ||
            typeof(context.state.price_data.price_csv[hida]) === 'undefined' ||
            typeof(context.state.price_data.price_csv[hida][open])==='undefined'
        ){
            context.commit('updatePriceData', {name:'price', value:0})
            return false;
        }
        const price_csv = context.state.price_data.price_csv[hida][open]
        //console.log('price_csv',price_csv)

        let wid = ''
        let hid = ''
        for(let i=0; i<price_csv.length; i++){
            if(style_selected2_name === 'プレーン小窓'){
                if(!context.state.step3_data.window_number){ return false }
                const window_num = context.state.step3_data.window_number
                wid = parseInt(window_num.replace(/台/g,''))
                if(parseInt(context.state.step3_data.width_size) >= 43){
                    wid+=3
                }
                if(
                    parseInt(price_csv[i].wid) === wid &&
                    parseInt(price_csv[i].hs) <= parseInt(height_size) && parseInt(price_csv[i].he) >= parseInt(height_size) &&
                    18 <= parseInt(width_size) && 65 >= parseInt(width_size)
                ){
                    price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price', value:price})

                    //ツインシェード
                    if(context.state.step3_data.atomaku_style !== ''){
                        context.dispatch('priceAtomakuCheck')
                    }
                    return false
                }
            }
            else if(group1_1 ==='クッション' && style_selected1_name !== 'クッションマチ付き'){
                if(
                    parseInt(price_csv[i].wid) === parseInt(context.state.step3_data.wid) &&
                    parseInt(price_csv[i].hid) === parseInt(context.state.step3_data.hid)
                ){
                    price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price', value:price})
                    return false
                }
            }else if(style_selected1_name === 'デコ付きバランス'){
                let deco_fringe_id = ''
                if(group1_1){
                    deco_fringe_id = context.state.xlsx_select_data.select_data[group1_1]['デコ付きバランス']['フリンジ品番を選ぶ'][context.state.step3_data.deco_fringe]
                }else{
                    return false
                }
                if(price_csv[i].hid === deco_fringe_id &&
                    parseInt(price_csv[i].ws) <= width_size && parseInt(price_csv[i].we) >= width_size &&
                    parseInt(context.state.step3_data.size_min_max['フラット']['片開き'].height_min) <= parseInt(height_size) && parseInt(context.state.step3_data.size_min_max['フラット']['片開き'].height_max) >= parseInt(height_size)
                ){
                    price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price', value:price})
                    return false
                }

            }else if(group2_1==='ベッドスプレッド'){
                let bed_size = context.state.xlsx_select_data.select_data[group2_1][context.state.step3_data.kurumi]['仕上りサイズを選択する'][context.state.step3_data.bed_size]
                let quilting_type = context.state.xlsx_select_data.select_data[group2_1][style_selected2_name]['スタンダード/キルティング'][context.state.step3_data.quilting_type]
                if(price_csv[i].wid === bed_size && price_csv[i].hid === quilting_type){
                    price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price', value:price})
                    return false
                }
            }else{
                if(parseInt(price_csv[i].ws) <= parseInt(width_size) && parseInt(price_csv[i].we) >= parseInt(width_size) &&
                    parseInt(price_csv[i].hs) <= parseInt(height_size) && parseInt(price_csv[i].he) >= parseInt(height_size) &&
                    context.state.step3_data.size_min_max[hida][open].width_min <= width_size && context.state.step3_data.size_min_max[hida][open].width_max >= width_size &&
                    context.state.step3_data.size_min_max[hida][open].height_min <= height_size && context.state.step3_data.size_min_max[hida][open].height_max >= height_size
                ){
                    price = parseInt(price_csv[i].price)
                    if(style_selected2_name === 'ステップシェード'){
                        price += 3000
                    }
                    price = price*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price', value:price})

                    wid = price_csv[i].wid
                    hid = price_csv[i].hid
                    break
                }
            }
        }

        //カーテン加算系
        if(
            wid !== '' && hid !== '' &&
            ((context.state.step2_data.style_selected2_id !== '' &&
            context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group2 !== '') ||
            context.state.step2_data.style_selected1_name === 'マルチカバー2サイドデコ')
        ){
            //id記録
            context.commit('updateOptionSelected', {name: 'wid', value: wid, no_check: true})
            context.commit('updateOptionSelected', {name: 'hid', value: hid, no_check: true})
            context.dispatch('priceAddCheck')
        }

        //裏地価格追加処理 フリンジ追加金額
        if(context.state.step3_data.ura !== '' && style_selected1_name !== 'デコ付きバランス'){
            context.dispatch('priceUraCheck')
        }

        //ツインシェード
        if(context.state.step3_data.atomaku_style !== ''){
            context.dispatch('priceAtomakuCheck')
        }
        return false
    },
    /**
     * 加算価格
     */
    priceAddCheck(context){
        if(context.state.price_data.price === 0){
            return false
        }
        let item_number = context.state.price_data.price_item_number
        let file_name = ''
        const wid = context.state.step3_data.wid
        const hid = context.state.step3_data.hid

        const style_selected2_name = context.state.step2_data.style_selected2_name
        const yokotsukai = context.state.xlsx_data.item_data['SH' + context.state.price_data.price_item_number]['ヨコ使い']
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        let group2 = ''
        let group2_1 = ''
        if(context.state.step2_data.style_selected2_id !== ''){
            group2 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group2
            group2_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group1
        }

        //カーテンスタイル加算固定系
        let tmp_price = []
        if(group2==='ボーダースタイル'){
            if (style_selected2_name === 'ボーダースタイル サイド') {
                if(context.state.step3_data.open==='片開き'){
                    file_name = 'BW23K.CSV'
                }else if(context.state.step3_data.open==='両開き'){
                    file_name = 'BW23R.CSV'
                }
            }else if (style_selected2_name === 'ボーダースタイル ボトム') {
                file_name = 'BZ23.CSV'
            }else if (style_selected2_name === '裏地付きボーダースタイル サイド') {
                if(context.state.step3_data.open==='片開き'){
                    file_name = 'UN23BK.CSV'

                }else if(context.state.step3_data.open==='両開き'){
                    file_name = 'UN23BR.CSV'
                }
            }
        }
        else if(group2==='フリンジスタイル'){
            if(!context.state.step3_data.fringe){
                return false
            }
            let fringe = context.state.step3_data.fringe.replace( /～/g , '-' )
            fringe = fringe.replace( /・/g , '-' )
            fringe = fringe.replace( /PV/g , '' )
            if (style_selected2_name === 'フリンジスタイルI型') {
                if(context.state.step3_data.fringe){
                    file_name = 'RJ23A-' + fringe + '.CSV'
                }
            }else if(style_selected2_name === 'フリンジスタイルZ型'){
                if(context.state.step3_data.fringe){
                    file_name = 'RZ23A-' + fringe + '.CSV'
                }
            }else if(style_selected2_name === 'フリンジスタイルL型'){
                if(context.state.step3_data.fringe){
                    file_name = 'RL23A-' + fringe + '.CSV'
                }
            }else if(style_selected2_name === '3段フリルスタイル ボトム'){
                if(context.state.step3_data.fringe){
                    file_name = 'HZ23H-' + fringe + '.CSV'
                }
            }else if(style_selected2_name === 'フリンジ付きボーダースタイル ボトム'){
                if(context.state.step3_data.fringe){
                    file_name = 'DZ23A-' + fringe + '.CSV'
                }
            }else if(style_selected2_name === 'フリンジ付きスカートスタイル トップ'){
                if(context.state.step3_data.fringe){
                    file_name = 'KT22A-' + fringe + '.CSV'
                }
            }
        }
        else if(group2==='吊元チェンジ'){
            if (style_selected2_name === 'ノンタックウェーブ') {
                if (yokotsukai === '○') {
                    file_name = 'CS1NA-Y.CSV'
                } else {
                    file_name = 'CS1NA-T.CSV'
                }
            } else if (style_selected2_name === 'ハトメスタイルM' || style_selected2_name === 'ハトメスタイルS') {
                file_name = 'CS1MA.CSV'
            } else if (style_selected2_name === 'タブトップスタイル') {
                file_name = 'CS0TA.CSV'
            } else if (style_selected2_name === 'ループトップスタイル') {
                if (yokotsukai === '○') {
                    file_name = 'CS1LA-Y.CSV'
                } else {
                    file_name = 'CS1LA-T.CSV'
                }
            }
        }
        else if(group2==='フリルスタイル') {
            if (yokotsukai === '○') {
                if (style_selected2_name === 'フリルスタイル Z型') {
                    file_name = 'FZ23F-Y.CSV'
                } else if (style_selected2_name === 'フリルスタイル L型') {
                    file_name = 'FL23F-Y.CSV'
                } else if (style_selected2_name === 'クロスオーバーフリル') {
                    file_name = 'FX33F-Y.CSV'
                } else if (style_selected2_name === 'セパレートフリル') {
                    file_name = 'FP23M-Y.CSV'
                } else {
                    return false
                }
            } else {
                if (style_selected2_name === 'フリルスタイル Z型') {
                    file_name = 'FZ23F-T.CSV'
                } else if (style_selected2_name === 'フリルスタイル L型') {
                    file_name = 'FL23F-T.CSV'
                } else if (style_selected2_name === 'クロスオーバーフリル') {
                    file_name = 'FX33F-T.CSV'
                } else {
                    return false
                }
            }
        }
        else if(group2==='トリムスタイル') {
            /*
            トリムスタイル Z型　トリムPV1212/PV1311　タテ使い加算価格			スタンダードに加算	2倍・2.5倍					TZ23T-PV1212_PV1311-T
            トリムスタイル Z型　トリムPV1212/PV1311　ヨコ使い加算価格			スタンダードに加算	2倍・2.5倍					TZ23T-PV1212_PV1311-Y
            トリムスタイル Z型　トリムPV1310　タテ使い加算価格			スタンダードに加算	2倍・2.5倍					TZ23T-PV1310-T
            トリムスタイル Z型　トリムPV1310　ヨコ使い加算価格			スタンダードに加算	2倍・2.5倍					TZ23T-PV1310-Y
             */
            if (context.state.step2_data.style_selected2_name === 'トリムスタイル Z型') {
                if (context.state.step3_data.trim === 'サイズ28cm:PV1310') {
                    if (yokotsukai === '○') {
                        file_name = 'TZ23T-PV1310-Y.CSV'
                    } else {
                        file_name = 'TZ23T-PV1310-T.CSV'
                    }
                } else if (context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311') {
                    if (yokotsukai === '○') {
                        file_name = 'TZ23T-PV1212_PV1311-Y.CSV'
                    } else {
                        file_name = 'TZ23T-PV1212_PV1311-T.CSV'
                    }
                }
            }
            /*
            ダブルトリムスタイル　トリムPV1213&PV1212　タテ使い加算価格			スタンダードに加算	2倍・2.5倍					WE23A-PV1213&PV1212-T
            ダブルトリムスタイル　トリムPV1213&PV1212　ヨコ使い加算価格			スタンダードに加算	2倍・2.5倍					WE23A-PV1213&PV1212-Y
            ダブルトリムスタイル　トリムPV1312&PV1310　タテ使い加算価格			スタンダードに加算	2倍・2.5倍					WE23A-PV1312&PV1310-T
            ダブルトリムスタイル　トリムPV1312&PV1310　ヨコ使い加算価格			スタンダードに加算	2倍・2.5倍					WE23A-PV1312&PV1310-Y
             */
            else if (style_selected2_name === 'ダブルトリムスタイル') {
                if (context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312＆サイズ18cm:PV1212・PV1311') {
                    if (yokotsukai === '○') {
                        file_name = 'WE23A-PV1213_PV1212-Y.CSV'
                    } else {
                        file_name = 'WE23A-PV1213_PV1212-T.CSV'
                    }
                } else if (context.state.step3_data.trim === 'サイズ8.5cm:PV1312＆サイズ28cm:PV1310') {
                    if (yokotsukai === '○') {
                        file_name = 'WE23A-PV1312_PV1310-Y.CSV'
                    } else {
                        file_name = 'WE23A-PV1312_PV1310-T.CSV'
                    }
                }
            }
            /*
            カフェスタイルトリム　トリムPV1212/PV1311　タテ使い加算価格			スタンダードに加算	2倍のみ					TC2QA-PV1212_PV1311-T
            カフェスタイルトリム　トリムPV1212/PV1311　ヨコ使い加算価格			スタンダードに加算	2倍のみ					TC2QA-PV1212_PV1311-Y
            カフェスタイルトリム　トリムPV1310　タテ使い加算価格			スタンダードに加算	2倍のみ					TC2QA-PV1310-T
            カフェスタイルトリム　トリムPV1310　ヨコ使い加算価格			スタンダードに加算	2倍のみ					TC2QA-PV1310-Y
             */
            else if (style_selected2_name === 'カフェスタイルトリム') {
                if (context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311') {
                    if (yokotsukai === '○') {
                        file_name = 'TC2QA-PV1212_PV1311-Y.CSV'
                    } else {
                        file_name = 'TC2QA-PV1212_PV1311-T.CSV'
                    }
                } else if (context.state.step3_data.trim === 'サイズ28cm:PV1310') {
                    if (yokotsukai === '○') {
                        file_name = 'TC2QA-PV1310-Y.CSV'
                    } else {
                        file_name = 'TC2QA-PV1310-T.CSV'
                    }
                }
            }
        }
        else if(group2==='スカラップスタイル') {
            if (yokotsukai === '○') {
                if (style_selected2_name === 'スカラップフリル センターウェーブ') {
                    file_name = 'FR23A-Y.CSV'
                }else if (style_selected2_name === 'フリースカラップフリル') {
                    file_name = 'FF23A-Y.CSV'
                }else if (style_selected2_name === 'スカラップトリム センターウェーブ') {
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TR23A-PV1213_PV1312-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TR23A-PV1212_PV1311-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TR23A-PV1310-Y.CSV'
                    }else {
                        return false
                    }
                }
                else if(style_selected2_name === 'スカラップフリル ウェーブ'){
                    file_name = 'FV23A-Y.CSV'
                }
                else if(style_selected2_name === 'スカラップフリル アーチ'){
                    file_name = 'FA23A-Y.CSV'
                }
                else if(style_selected2_name === 'スカラップフリル M'){
                    file_name = 'FM23A-Y.CSV'
                }
                else if(style_selected2_name === 'スカラップトリム ウェーブ'){
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TV23A-PV1213_PV1312-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TV23A-PV1212_PV1311-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TV23A-PV1310-Y.CSV'
                    }
                }
                else if(style_selected2_name === 'スカラップトリム アーチ'){
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TA23A-PV1213_PV1312-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TA23A-PV1212_PV1311-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TA23A-PV1310-Y.CSV'
                    }
                }
                else if(style_selected2_name === 'スカラップトリム M'){
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TM23A-PV1213_PV1312-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TM23A-PV1212_PV1311-Y.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TM23A-PV1310-Y.CSV'
                    }
                }
            } else {
                if (style_selected2_name === 'スカラップフリル センターウェーブ') {
                    file_name = 'FR23A-T.CSV' //特殊で3から始まる
                }
                else if (style_selected2_name === 'フリースカラップフリル') {
                    file_name = 'FF23A-T.CSV'
                }
                else if (style_selected2_name === 'スカラップトリム センターウェーブ') {
                    if (context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312') {
                        file_name = 'TR23A-PV1213_PV1312-T.CSV'
                    } else if (context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311') {
                        file_name = 'TR23A-PV1212_PV1311-T.CSV'
                    } else if (context.state.step3_data.trim === 'サイズ28cm:PV1310') {
                        file_name = 'TR23A-PV1310-T.CSV'
                    }
                }
                else if(style_selected2_name === 'スカラップフリル ウェーブ'){
                    file_name = 'FV23A-T.CSV'
                }
                else if(style_selected2_name === 'スカラップフリル アーチ'){
                    file_name = 'FA23A-T.CSV'
                }
                else if(style_selected2_name === 'スカラップフリル M'){
                    file_name = 'FM23A-T.CSV'
                }
                else if(style_selected2_name === 'スカラップトリム ウェーブ'){
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TV23A-PV1213_PV1312-T.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TV23A-PV1212_PV1311-T.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TV23A-PV1310-T.CSV'
                    }
                }
                else if(style_selected2_name === 'スカラップトリム アーチ'){
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TA23A-PV1213_PV1312-T.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TA23A-PV1212_PV1311-T.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TA23A-PV1310-T.CSV'
                    }
                }
                else if(style_selected2_name === 'スカラップトリム M'){
                    if(context.state.step3_data.trim === 'サイズ8.5cm:PV1213・PV1312'){
                        file_name = 'TM23A-PV1213_PV1312-T.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ18cm:PV1212・PV1311'){
                        file_name = 'TM23A-PV1212_PV1311-T.CSV'
                    }else if(context.state.step3_data.trim === 'サイズ28cm:PV1310'){
                        file_name = 'TM23A-PV1310-T.CSV'
                    }
                }
            }
        }
        //シェード関係
        else if(group2_1=='ロールスクリーン＆ローマンシェード') {
            if (style_selected2_name === 'プレーンシェードトリム') {
                if (yokotsukai === '○') {
                    if (context.state.step3_data.mecha === 'ドラム式') {
                        file_name = item_number + 'R-64DY.CSV'
                    } else if (context.state.step3_data.mecha === 'コード式') {
                        file_name = item_number + 'R-64CY.CSV'
                    } else if (context.state.step3_data.mecha === 'ループレス式') {
                        file_name = item_number + 'R-64LY.CSV'
                    }
                } else {
                    if (context.state.step3_data.mecha === 'ドラム式') {
                        file_name = item_number + 'R-64DT.CSV'
                    } else if (context.state.step3_data.mecha === 'コード式') {
                        file_name = item_number + 'R-64CT.CSV'
                    } else if (context.state.step3_data.mecha === 'ループレス式') {
                        file_name = item_number + 'R-64LT.CSV'
                    }
                }
            } else if (style_selected2_name === 'プレーンシェードボトムフリンジ付き') {
                if (yokotsukai === '○') {
                    if (context.state.step3_data.mecha === 'ドラム式') {
                        file_name = item_number + 'R-63FDY.CSV'
                    } else if (context.state.step3_data.mecha === 'コード式') {
                        file_name = item_number + 'R-63FCY.CSV'
                    } else if (context.state.step3_data.mecha === 'ループレス式') {
                        file_name = item_number + 'R-63FLY.CSV'
                    }
                } else {
                    if (context.state.step3_data.mecha === 'ドラム式') {
                        file_name = item_number + 'R-63FDT.CSV'
                    } else if (context.state.step3_data.mecha === 'コード式') {
                        file_name = item_number + 'R-63FCT.CSV'
                    } else if (context.state.step3_data.mecha === 'ループレス式') {
                        file_name = item_number + 'R-63FLT.CSV'
                    }
                }
            } else if (style_selected2_name === 'バルーンシェードフリル') {
                if (context.state.step3_data.mecha === 'ドラム式') {
                    file_name = item_number + 'R-62DY.CSV'
                } else if (context.state.step3_data.mecha === 'コード式') {
                    file_name = item_number + 'R-62CY.CSV'
                } else if (context.state.step3_data.mecha === 'ループレス式') {
                    file_name = item_number + 'R-62LY.CSV'
                }
            }
        }
        else if(context.state.step2_data.style_selected1_name === 'マルチカバー2サイドデコ'){
            file_name = item_number+'B-91FT.CSV'
        }

        if(file_name === ''){
            return false;
        }

        //同じ基本価格は読まない
        if(file_name != context.state.price_data.price_add_file){
            const path = './item_data/price_data/'
            context.commit('updatePriceData', {name:'price_add_file', value:file_name})
            const req = new XMLHttpRequest()
            req.open('GET', path+file_name, true)
            req.responseType = 'text'
            const scope = context

            //ローディングをつける　TODO
            req.onload = function () {
                if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                    console.log('ファイル読み込みエラー')
                    context.commit('updateErrorMessage', 'ファイル読み込みエラー')
                    return false
                }
                console.log('加算価格ファイル',file_name)
                context.commit('updateErrorMessage', '')
                const data = req.response
                //データを処理
                context.dispatch('csvAddFormating', data)
            }
            req.onerror = function() {
                console.log('ファイル読み込みエラー')
                context.commit('updateErrorMessage', 'ファイル読み込みエラー')
                return false
            }
            req.send();
        }else{
            context.dispatch('priceAddCalculation')
        }
    },
    csvAddFormating(context, payload){
        // 行単位で配列にする
        let lineArr = payload.split("\n")
        // 行と列の二次元配列にする
        let itemArr = []
        let csv_table = '<table class="price_list">'
        if(
            context.state.step2_data.style_selected2_name==='プレーンシェードトリム' ||
            context.state.step2_data.style_selected2_name==='プレーンシェードボトムフリンジ付き' ||
            context.state.step2_data.style_selected2_name==='バルーンシェードフリル' ||
            context.state.step2_data.style_selected1_name === 'マルチカバー2サイドデコ'
        ){
            for (let i = 0; i < lineArr.length; i++) {
                itemArr[i] = lineArr[i].split('","')
                if(itemArr[i].length===1){
                    continue
                }
                csv_table += '<tr>'
                for(let j=0; j < itemArr[i].length; j++){
                    itemArr[i][j] = itemArr[i][j].replace(/\r/g , '')
                    itemArr[i][j] = itemArr[i][j].replace(/"/g , '')
                    itemArr[i][j] = itemArr[i][j].replace(/,/g , '')
                    csv_table += '<td>'+itemArr[i][j]+'</td>'
                }
                csv_table += '</tr>'
            }
            csv_table += '</table>'
            context.commit('updatePriceData', {name:'price_load_add_data', value:csv_table})
        }else{
            for (let i = 0; i < lineArr.length; i++) {
                itemArr[i] = lineArr[i].split(',')
                if(itemArr[i].length===1){
                    continue
                }
                csv_table += '<tr>'
                for(let j=0; j < itemArr[i].length; j++){
                    itemArr[i][j] = itemArr[i][j].replace(/\r/g , '')
                    csv_table += '<td>'+itemArr[i][j]+'</td>'
                }
                csv_table += '</tr>'
            }
            csv_table += '</table>'
            context.commit('updatePriceData', {name:'price_load_add_data', value:csv_table})
        }

        let price_data = {}
        let w,ws,we,wid,h,hs,he,hid

        const style_selected1_name = context.state.step2_data.style_selected1_name
        const style_selected2_name = context.state.step2_data.style_selected2_name
        const search_data = context.state.search_data
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        let group2 = ''
        let group2_1 = ''
        if(context.state.step2_data.style_selected2_id !== ''){
            group2 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group2
            group2_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group1
        }
        let yokotsukai = ''
        if(context.state.xlsx_data.item_data && context.state.price_data.price_item_number){
            yokotsukai = context.state.xlsx_data.item_data['SH' + context.state.price_data.price_item_number]['ヨコ使い']
        }

        let hida = 'フラット'
        let open = '片開き'

        let setting_index = {}
        if(
            style_selected2_name === 'ボーダースタイル サイド' ||
            style_selected2_name === '裏地付きボーダースタイル サイド' ||
            style_selected2_name==='ループトップスタイル' ||
            style_selected2_name==='フリルスタイル L型' ||
            style_selected2_name==='フリルスタイル Z型' ||
            style_selected2_name==='トリムスタイル Z型' ||
            style_selected2_name==='ダブルトリムスタイル' ||
            group2==='フリンジスタイル' ||
            (group2 === '吊元チェンジ' && yokotsukai !== '○') ||
            (group2 === 'フリルスタイル' && yokotsukai !== '○') ||
            (group2 === 'トリムスタイル' && yokotsukai !== '○') ||
            (group2 === 'スカラップスタイル' && yokotsukai !== '○')
        ){
            //open = context.state.step3_data.open
            setting_index['フラット'] = {}
            setting_index['フラット']['片開き'] = 0
            setting_index['フラット']['両開き'] = 0
        }
        else if(style_selected2_name==='ノンタックウェーブ'){
            setting_index['1.5倍ヒダ'] = {}
            setting_index['1.5倍ヒダ']['片開き'] = 0
            setting_index['1.5倍ヒダ']['両開き'] = 1
        }
        else if(group2 === 'フリルスタイル'){
            setting_index['2倍ヒダ'] = {}
            setting_index['2.5倍ヒダ'] = {}
            if(style_selected2_name==='クロスオーバーフリル'){
                setting_index['2.5倍ヒダ']['片開き'] = 0
                setting_index['2.5倍ヒダ']['両開き'] = 0
            }else{
                setting_index['2倍ヒダ']['片開き'] = 0
                setting_index['2.5倍ヒダ']['片開き'] = 1
                setting_index['2倍ヒダ']['両開き'] = 0
                setting_index['2.5倍ヒダ']['両開き'] = 1
            }
        }
        else if(group2 === 'トリムスタイル'){
            setting_index['2倍ヒダ'] = {}
            setting_index['2.5倍ヒダ'] = {}
            if(style_selected2_name==='カフェスタイルトリム'){
                setting_index['2倍ヒダ']['片開き'] = 1
            }else{
                setting_index['2倍ヒダ']['片開き'] = 1
                setting_index['2.5倍ヒダ']['片開き'] = 2
                setting_index['2倍ヒダ']['両開き'] = 1
                setting_index['2.5倍ヒダ']['両開き'] = 2
            }
        }
        else if(group2 === 'スカラップスタイル'){
            setting_index['2倍ヒダ'] = {}
            setting_index['2.5倍ヒダ'] = {}
            if(style_selected2_name.match(/スカラップフリル/)){
                setting_index['2倍ヒダ']['片開き'] = 0
                setting_index['2.5倍ヒダ']['片開き'] = 1
            }else{
                setting_index['2倍ヒダ']['片開き'] = 1
                setting_index['2.5倍ヒダ']['片開き'] = 2
            }
        }

        else if(style_selected2_name==='ボーダースタイル ボトム'){
            hida = context.state.step3_data.hida
            open = context.state.step3_data.open
            if(hida === undefined){
                return false
            }
            hida = hida.split('/')[0]
            hida = hida.replace(/約/g,'')
            if(hida==='1倍'){
                hida = 'フラット'
            }
            else if(hida==='2.3倍'){
                hida = '2倍ヒダ'
            }
            else{
                hida = hida+'ヒダ'
            }

            if (yokotsukai === '○') {
                setting_index = {
                    '2倍ヒダ': {'片開き': 0, '両開き': 1,}
                }
            } else{
                setting_index = {
                    '2倍ヒダ': {'片開き': 0, '両開き': 2,}
                }
            }

            let is_flat = false
            for (let i = 0; i < itemArr.length - 1; i++) {
                if (itemArr[i][0] === '1.5倍ヒダ' || itemArr[i][0] === '2.5倍ヒダ' || itemArr[i][0] === 'フラット') {
                    setting_index[itemArr[i][0]] = {}
                    setting_index[itemArr[i][0]]['片開き'] = i
                    setting_index[itemArr[i][0]]['両開き'] = i + 1
                    if(itemArr[i][0] === 'フラット'){
                        is_flat = true
                    }
                }else if(i>2 && itemArr[i][0] === '' && !is_flat){
                    setting_index['フラット'] = {}
                    setting_index['フラット']['片開き'] = i
                    setting_index['フラット']['両開き'] = i + 1
                    is_flat = true
                }else if(i>2 && itemArr[i][0] === '' && is_flat){
                    setting_index['2.5倍ヒダ'] = {}
                    setting_index['2.5倍ヒダ']['片開き'] = i
                    setting_index['2.5倍ヒダ']['両開き'] = i + 1
                }
            }
        }
        else{
            setting_index = {'フラット': { '片開き': 0}}
        }


        let size_min_max = {}
        for(let hida in setting_index){
            price_data[hida] = {}
            size_min_max[hida] = {}
            for(let open in setting_index[hida]){
                price_data[hida][open] =[]
                size_min_max[hida][open] = {}
                //各ヒダの巾情報位置
                let index = setting_index[hida][open]
                let height_min = ''
                let height_max = ''
                let width_min = ''
                let width_max = ''
                let item_price = ''
                hid = 0
                for(let i=0; i<itemArr.length-1; i++){
                    if (!itemArr[i][0].match(/〜/) && !itemArr[i][0].match(/～/)) {
                        continue
                    }
                    if(itemArr[i][0].match(/〜/)){
                        h = itemArr[i][0].split('〜')
                    }else if(itemArr[i][0].match(/～/)){
                        h = itemArr[i][0].split('～')
                    }

                    hs = h[0]
                    he = h[1]
                    hid++
                    if(height_min==='' && hs !=='' && !isNaN(hs)){
                        height_min = parseInt(hs)
                    }else if(height_min===''){
                        //height_min = context.state.step3_data.id_size[hida]['hid'][hid]['hs']
                    }
                    height_max = parseInt(he)
                    wid = 0
                    for(let j=1; j < itemArr[i].length; j++){
                        ws = ''
                        we = ''
                        w = ''
                        if (itemArr[index][j].match(/〜/) || itemArr[index][j].match(/～/)) {
                            if(itemArr[index][j].match(/〜/)){
                                w = itemArr[index][j].split('〜')
                            }else if(itemArr[index][j].match(/～/)){
                                w = itemArr[index][j].split('～')
                            }
                            ws = w[0]
                            we = w[1]

                        }else if(itemArr[index][j].match(/−/)){
                            continue
                        }else{
                            ws = w
                            we = w
                        }
                        wid++
                        if(width_min==='' && ws !== ''){
                            width_min = parseInt(ws)
                        }else if(width_min===''){
                            //width_min = context.state.step3_data.id_size[hida]['wid'][wid]['ws']
                        }
                        if(parseInt(we) > 0){
                            width_max = parseInt(we)
                        }else{
                            //width_max = context.state.step3_data.id_size[hida]['wid'][wid]['we']
                        }
                        item_price = itemArr[i][j]
                        //価格表()の価格は高さが200cmまで
                        if (itemArr[i][j].match(/\(/)) {
                            itemArr[i][j] = itemArr[i][j].replace(/\(/g , '')
                            itemArr[i][j] = itemArr[i][j].replace(/\)/g , '')
                            if(style_selected2_name.match('/シェード/')){
                                price_data[hida][open].push(
                                    {
                                        ws:ws,
                                        we:we,
                                        wid:wid,
                                        hs:hs,
                                        he:200,
                                        hid:hid,
                                        price:itemArr[i][j]
                                    }
                                )
                                continue
                            }
                        }
                        else if(itemArr[i][j]==='−'){
                            continue
                        }
                        let a=1
                        price_data[hida][open].push(
                            {
                                ws:ws,
                                we:we,
                                wid:wid,
                                hs:hs,
                                he:he,
                                hid:hid,
                                price:itemArr[i][j]
                            }
                        )
                    }
                }
                size_min_max[hida][open] = {wid:wid, hid:hid, width_min:width_min, height_min:height_min, width_max:width_max, height_max:height_max}
            }
        }
        context.commit('updateOptionSelected', {name: 'add_size_min_max', value: size_min_max, no_check: true})
        context.commit('updatePriceData', {name:'price_add_csv', value:price_data})
        context.dispatch('priceAddCalculation')
    },
    priceAddCalculation(context){
        if(context.state.price_data.price_add_file ===''){return false}
        if(context.state.price_data.price_add_csv === '') {return false}

        const wid = context.state.step3_data.wid
        const hid = context.state.step3_data.hid
        const width_size = parseInt(context.state.step3_data.width_size)
        const height_size = parseInt(context.state.step3_data.height_size)

        const style_selected1_name = context.state.step2_data.style_selected1_name
        const style_selected2_name = context.state.step2_data.style_selected2_name
        const yokotsukai = context.state.xlsx_data.item_data['SH' + context.state.price_data.price_item_number]['ヨコ使い']
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        let group2 = ''
        let group2_1 = ''
        if(context.state.step2_data.style_selected2_id !== ''){
            group2 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group2
            group2_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected2_id].group1
        }

        let set_number = context.state.step4_data.set_number

        //if(hida === '' || open === ''){return false}
        //console.log('priceCalculation',set_number+': typeof='+typeof(set_number))

        if(!set_number){ set_number=0 }

        let hida = 'フラット'
        let open = '片開き'

        if (
            style_selected2_name === 'ボーダースタイル サイド' ||
            style_selected2_name==='裏地付きボーダースタイル サイド' ||
            style_selected2_name==='ループトップスタイル' ||
            style_selected2_name==='フリルスタイル L型' ||
            style_selected2_name==='フリルスタイル Z型' ||
            style_selected2_name==='トリムスタイル Z型' ||
            style_selected2_name==='ダブルトリムスタイル' ||
            group2==='フリンジスタイル' ||
            (group2 === '吊元チェンジ' && yokotsukai !== '○') ||
            (group2 === 'フリルスタイル' && yokotsukai !== '○') ||
            (group2 === 'トリムスタイル' && yokotsukai !== '○') ||
            (group2 === 'スカラップスタイル' && yokotsukai !== '○')
        ) {
            hida = 'フラット'
            open = context.state.step3_data.open
        }
        else if(
            style_selected2_name === 'ボーダースタイル ボトム' ||
            group2 === '吊元チェンジ' ||
            group2 === 'フリルスタイル' ||
            group2 === 'トリムスタイル' ||
            group2 === 'スカラップスタイル'
        ){
            hida = context.state.step3_data.hida
            open = context.state.step3_data.open
            hida = hida.split('/')[0]
            hida = hida.replace(/約/g,'')
            if(hida==='1倍'){
                hida = 'フラット'
            }
            else if(hida==='2.3倍'){
                hida = '2倍ヒダ'
            }
            else{
                hida = hida+'ヒダ'
            }
        }
        //開閉不可対策
        if(open === '開閉不可'){
            open='片開き';
        }
        if(!context.state.price_data.price_add_csv || !context.state.price_data.price_add_csv[hida] || !context.state.price_data.price_add_csv[hida][open]){
            return false
        }
        const price_csv = context.state.price_data.price_add_csv[hida][open]

        if(group2==='ボーダースタイル'){
            for(let i=0; i<price_csv.length; i++) {
                if (style_selected2_name === 'ボーダースタイル サイド') {
                    if (
                        parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                    ){
                        let price = parseInt(price_csv[i].price) * parseInt(set_number)
                        context.commit('updatePriceData', {name: 'price_add', value: price})
                        return false
                    }
                } else if (style_selected2_name === 'ボーダースタイル ボトム') {
                    if(
                        parseInt(price_csv[i].ws) <= width_size && parseInt(price_csv[i].we) >= width_size &&
                        parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                    ){
                        const price = parseInt(price_csv[i].price)*parseInt(set_number)
                        context.commit('updatePriceData', {name:'price_add', value:price})
                        return false
                    }
                } else if (style_selected2_name === '裏地付きボーダースタイル サイド') {
                    if (
                        price_csv[i].wid === wid &&
                        parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                    ) {
                        const price = parseInt(price_csv[i].price) * parseInt(set_number)
                        context.commit('updatePriceData', {name: 'price_add', value: price})
                        return false
                    }
                }
            }
        }
        else if(group2==='フリンジスタイル'){
            for(let i=0; i<price_csv.length; i++){
                if (style_selected2_name === 'フリンジスタイルI型') {
                    if(price_csv[i].hs <= height_size && price_csv[i].he >= height_size){
                        let price = parseInt(price_csv[i].price)*parseInt(set_number)
                        context.commit('updatePriceData', {name:'price_add', value:price})
                        return false
                    }
                }else{
                    if(price_csv[i].wid === wid &&
                        parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size){
                        const price = parseInt(price_csv[i].price)*parseInt(set_number)
                        context.commit('updatePriceData', {name:'price_add', value:price})
                        return false
                    }
                }
            }
        }
        else if(
            (
                style_selected2_name === 'スカラップフリル センターウェーブ' ||
                style_selected2_name === 'スカラップトリム センターウェーブ'
            ) && yokotsukai !== '○'
        ){
            for(let i=0; i<price_csv.length; i++){
                if(
                    price_csv[i].wid+2 == wid &&
                    parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                ){
                    const price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_add', value:price})
                    return false
                }
            }
        }
        else if(
            style_selected2_name==='ループトップスタイル' ||
            style_selected2_name==='フリルスタイル L型' ||
            style_selected2_name==='フリルスタイル Z型' ||
            style_selected2_name==='トリムスタイル Z型' ||
            style_selected2_name==='ダブルトリムスタイル' ||
            (group2 === '吊元チェンジ' && yokotsukai !== '○') ||
            (group2 === 'フリルスタイル' && yokotsukai !== '○') ||
            (group2 === 'トリムスタイル' && yokotsukai !== '○') ||
            (group2 === 'スカラップスタイル' && yokotsukai !== '○')
        ){
            for(let i=0; i<price_csv.length; i++) {
                if (
                    price_csv[i].wid === wid &&
                    parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                ) {
                    const price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name: 'price_add', value: price})
                    return false
                }
            }
        }
        else if (
            group2 === '吊元チェンジ' ||
            group2 === 'フリルスタイル' ||
            group2 === 'トリムスタイル' ||
            group2 === 'スカラップスタイル'
        ) {
            for(let i=0; i<price_csv.length; i++){
                if(
                    parseInt(price_csv[i].ws) <= width_size && parseInt(price_csv[i].we) >= width_size &&
                    parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                ){
                    const price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_add', value:price})
                    return false
                }
            }
        }

        //以下シェード関係
        else if(
            style_selected2_name==='プレーンシェードトリム' ||
            style_selected2_name==='プレーンシェードボトムフリンジ付き'
        ) {
            let select_id = ''
            if(style_selected2_name==='プレーンシェードトリム'){
                select_id = context.state.xlsx_select_data.select_data[group2_1][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'][context.state.step3_data.trim]
            }
            else if(style_selected2_name==='プレーンシェードボトムフリンジ付き'){
                select_id = context.state.xlsx_select_data.select_data[group2_1][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'][context.state.step3_data.fringe]
            }
            for(let i=0; i<price_csv.length; i++){
                if(
                    price_csv[i].hid === select_id &&
                    parseInt(price_csv[i].ws) <= width_size && parseInt(price_csv[i].we) >= width_size
                ){
                    let price = parseInt(price_csv[i].price)*parseInt(set_number)
                    //console.log(i+" pcrice="+price)
                    context.commit('updatePriceData', {name:'price_add', value:price})
                    return false
                }
            }
        }
        else if(
            style_selected2_name==='バルーンシェードフリル'
        ) {
            for(let i=0; i<price_csv.length; i++){
                if(
                    parseInt(price_csv[i].ws) <= width_size && parseInt(price_csv[i].we) >= width_size
                ){
                    const price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_add', value:price})
                    return false
                }
            }
        }else if(style_selected1_name === 'マルチカバー2サイドデコ'){
            const fringe_id = context.state.xlsx_select_data.select_data[group1_1][style_selected1_name]['フリンジ品番を選ぶ'][context.state.step3_data.fringe]
            for(let i=0; i<price_csv.length; i++){
                if(
                    price_csv[i].wid == fringe_id &&
                    parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
                ){
                    const price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_add', value:price})
                    return false
                }
            }
        }

        else {
            for(let i=0; i<price_csv.length; i++){
                if(price_csv[i].wid == wid && price_csv[i].hid == hid) {
                    const price = parseInt(price_csv[i].price)*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_add', value:price})
                    return false
                }
            }
        }
        context.commit('updatePriceData', {name: 'price_add', value: '製作不可のサイズです'})
        return false
    },

    /**
     * 裏地価格
     */
    priceUraCheck(context){
        if(context.state.price_data.price === 0){
            return false
        }
        let item_number = context.state.price_data.price_item_number
        let ura_file_name = ''
        if(context.state.step3_data.ura==='裏地なし'){
            context.commit('updatePriceData', {name:'price_ura_file', value:''})
            return false
        }
        else if(context.state.step3_data.ura==='裏地一体縫製'){
            if(context.state.step2_data.style_selected1_name==='ソフトウェーブ縫製'){
                ura_file_name='5371SWL.CSV'
            } else if(context.state.step2_data.style_selected1_name==='ファインウェーブ縫製'){
                ura_file_name='5371FWL.CSV'
            } else if(context.state.step2_data.style_selected1_name==='スタンダード縫製'){
                ura_file_name='5371HL.CSV'
            } else if(context.state.step2_data.style_selected1_name==='filo縫製'){
                ura_file_name='5371FLFW.CSV'
            }
        } else if(context.state.step3_data.ura==='脱着可能裏地'){
            ura_file_name='5371NL.CSV'
        } else if(context.state.step3_data.ura==='裏地あり'){
            if(context.state.step2_data.style_selected2_name==='プレーンシェード'){
                ura_file_name='5371L-63.CSV'
            } else if(context.state.step2_data.style_selected2_name==='シャープシェード'){
                ura_file_name='5371L-65.CSV'
            }
        } else{
            return false
        }

        //同じ基本価格は読まない
        if(ura_file_name != context.state.price_data.price_ura_file){
            const path = './item_data/price_data/'
            context.commit('updatePriceData', {name:'price_ura_file', value:ura_file_name})
            const req = new XMLHttpRequest()
            req.open('GET', path+ura_file_name, true)
            req.responseType = 'text'
            const scope = context

            //ローディングをつける　TODO
            req.onload = function () {
                if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                    //console.log('ファイル読み込みエラー')
                    context.commit('updateErrorMessage', 'ファイル読み込みエラー')
                    return false
                }
                context.commit('updateErrorMessage', '')
                const data = req.response
                //データを処理
                context.dispatch('csvUraFormating', data)
            }
            req.onerror = function() {
                //console.log('ファイル読み込みエラー')
                context.commit('updateErrorMessage', 'ファイル読み込みエラー')
                return false
            }
            req.send();
        }else{
            context.dispatch('priceUraCalculation')
        }
    },
    csvUraFormating(context, payload){
        // 行単位で配列にする
        const lineArr = payload.split("\n")
        // 行と列の二次元配列にする
        let itemArr = []
        for (let i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split('","')
            for(let j=0; j < itemArr[i].length; j++){
                itemArr[i][j] = itemArr[i][j].replace(/\r/g , '')
                itemArr[i][j] = itemArr[i][j].replace(/"/g , '')
                itemArr[i][j] = itemArr[i][j].replace(/,/g , '')
            }
        }
        const group1 = context.state.step2_data.style_selected1_name
        const search_data = context.state.search_data
        let price_data = {}
        let w,ws,we,wid,h,hs,he,hid
        let setting_index = {}

        //カーテン
        if(context.state.step3_data.ura==='裏地なし'){
            return false
        }else if(context.state.step3_data.ura==='脱着可能裏地'){
            setting_index = {'フラット': { '片開き': 1, '両開き': 14, }}
        }
        else if(context.state.step3_data.ura==='裏地一体縫製'){
            if(group1==='スタンダード縫製' || group1==='ソフトウェーブ縫製' || group1==='ファインウェーブ縫製' || group1==='filo縫製') {
                if(search_data['ドレープ/レース']==='ドレープ'){
                    setting_index = {
                        '2倍ヒダ': { '片開き': 0, '両開き': 2, }
                    }
                }
                for (let i = 0; i < itemArr.length - 1; i++) {
                    if (itemArr[i][0] === '1.5倍ヒダ' || itemArr[i][0] === '2.5倍ヒダ' || itemArr[i][0] === 'フラット') {
                        setting_index[itemArr[i][0]] = {}
                        setting_index[itemArr[i][0]]['片開き'] = i
                        setting_index[itemArr[i][0]]['両開き'] = i + 1
                    }
                }
            }
        }
        //ロールスクリーン
        else if(context.state.step3_data.ura==='裏地あり'){
            setting_index = {'フラット': { '片開き': 1}}
        }
        else {
            for (let i = 0; i < itemArr.length - 1; i++) {
                if (itemArr[i][0] === '仕上り巾(cm)') {
                    setting_index['フラット'] = {}
                    setting_index['フラット']['片開き'] = i
                    break
                }
            }
        }

        for(let hida in setting_index){
            price_data[hida] = {}
            for(let open in setting_index[hida]){
                price_data[hida][open] =[]
                //各ヒダの巾情報位置
                let index = setting_index[hida][open]
                hid = 0
                for(let i=0; i<itemArr.length-1; i++){
                    if (!itemArr[i][0].match(/〜/) &&  !itemArr[i][0].match(/～/)) {
                        continue
                    }
                    if (itemArr[i][0].match(/〜/)) {
                        h = itemArr[i][0].split('〜')
                    }else if(itemArr[i][0].match(/～/)){
                        h = itemArr[i][0].split('～')
                    }

                    hs = h[0]
                    he = h[1]
                    hid++
                    wid = 0
                    for(let j=1; j < itemArr[i].length; j++){
                        if (!itemArr[index][j].match(/〜/) && !itemArr[index][j].match(/～/)) {
                            continue
                        }
                        if(itemArr[index][j].match(/〜/)){
                            w = itemArr[index][j].split('〜')
                        }else if(itemArr[index][j].match(/～/)){
                            w = itemArr[index][j].split('～')
                        }
                        ws = w[0]
                        we = w[1]
                        wid++
                        if(itemArr[i][j]==='-'){
                            continue
                        }
                        price_data[hida][open].push(
                            {
                                ws:ws,
                                we:we,
                                wid:wid,
                                hs:hs,
                                he:he,
                                hid:hid,
                                price:itemArr[i][j]
                            }
                        )
                    }
                }
            }
        }
        context.commit('updatePriceData', {name:'price_ura_csv', value:price_data})
        context.dispatch('priceUraCalculation')
    },
    priceUraCalculation(context){
        if(context.state.price_data.price_ura_file ===''){return false}
        if(context.state.price_data.price_ura_csv === '') {return false}
        let hida = context.state.step3_data.hida
        const open = context.state.step3_data.open
        const width_size = parseInt(context.state.step3_data.width_size)
        const height_size = parseInt(context.state.step3_data.height_size)
        const group1 = context.state.step2_data.style_selected1_name
        const group2 = context.state.step2_data.style_selected2_name

        let set_number = context.state.step4_data.set_number
        //console.log('set_number='+set_number+' hida='+hida+' open='+open+' width='+width_size+' height='+height_size)
        if(hida === null || open=== null || width_size === null || height_size==null){return false}
        if(hida === '' || open === '' || width_size === '' || height_size === ''){return false}
        if(hida === undefined){return false}
        //console.log('priceCalculation',set_number+': typeof='+typeof(set_number))
        if(!set_number){ set_number=0 }
        if(context.state.step3_data.ura==='脱着可能裏地'){
            hida = 'フラット'
        }else if(context.state.step3_data.ura==='裏地一体縫製'){
            hida = hida.split('/')[0]
            hida = hida.replace(/約/g,'')
            if(hida==='1倍'){
                hida = 'フラット'
            }
            else if(hida==='2.3倍'){
                hida = '2倍ヒダ'
            }
            else{
                hida = hida+'ヒダ'
            }
        }
        else if(context.state.step3_data.ura==='裏地あり'){
            hida = 'フラット'
        }
        else {
            hida = 'フラット'
        }

        const price_csv = context.state.price_data.price_ura_csv[hida][open]

        for(let i=0; i<price_csv.length; i++){
            if(parseInt(price_csv[i].ws) <= width_size && parseInt(price_csv[i].we) >= width_size &&
                parseInt(price_csv[i].hs) <= height_size && parseInt(price_csv[i].he) >= height_size
            ){
                const price = parseInt(price_csv[i].price)*parseInt(set_number)
                context.commit('updatePriceData', {name:'price_ura', value:price})
                return false
            }
        }

        return false
    },

    /**
     * 後幕価格
     */
    priceAtomakuCheck(context){
        //価格初期化
        context.commit('updatePriceData', {name:'price_atomaku', value:0})
        if(context.state.price_data.price === 0){
            return false
        }
        //品番チェック
        if(
            context.state.step1_data.atomaku_number === '' ||
            typeof(context.state.xlsx_data.item_data) === 'undefined' ||
            typeof(context.state.xlsx_data.item_data['SH'+context.state.step1_data.atomaku_number]) === 'undefined'
        ) {
            context.commit('updatePriceData', {name:'price_atomaku', value:0})
            return false
        }
        const path = './item_data/price_data/'
        context.dispatch('getAtomakuFileName')
        const file = context.state.price_data.check_atomaku_file
        if(file === ''){return false}
        //同じ基本価格は読まない
        if(file != context.state.price_data.price_atomaku_file){
            context.commit('updatePriceData', {name:'price_atomaku_file', value:file})
            const req = new XMLHttpRequest()
            req.open('GET', path+file, true)
            req.responseType = 'text'
            const scope = context

            //ローディングをつける　TODO
            req.onload = function () {
                if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                    //console.log('ファイル読み込みエラー')
                    context.commit('updateAtomakuErrorMessage', 'ファイル読み込みエラー')
                    return false
                }
                context.commit('updateAtomakuErrorMessage', '')
                const data = req.response
                //データを処理
                context.dispatch('csvAtomakuFormating', data)
            }
            req.onerror = function() {
                //console.log('ファイル読み込みエラー')
                context.commit('updateAtomakuErrorMessage', 'ファイル読み込みエラー')
                return false
            }
            req.send();
        }else{
            context.dispatch('priceAtomakuCalculation')
        }
    },
    /**
     * 後幕ファイル名取得
     */
    getAtomakuFileName(context){
        let item_number = context.state.step1_data.atomaku_number
        let style_selected1_name = context.state.step2_data.style_selected1_name
        let style_selected2_name = context.state.step2_data.style_selected2_name
        if(context.state.step3_data.atomaku_style){
            style_selected2_name = context.state.step3_data.atomaku_style
        }
        const search_data = context.state.search_atomaku_data
        const file_rule = context.state.xlsx_data.file_rule
        if (0 === Object.keys(search_data).length) {return false}
        context.commit('updatePriceData', {name:'price_atomaku_number', value:item_number})
        //価格は先頭品番のみ
        if(context.state.xlsx_data.item_data['SH'+item_number]['先頭'] !=='*'){
            for(let j=1; j<50; j++){
                if(context.state.xlsx_data.item_data['SH'+(parseInt(item_number)-j)]['先頭'] ==='*'){
                    item_number = parseInt(item_number)-j
                    context.commit('updatePriceData', {name:'price_atomaku_number', value:item_number})
                    break
                }
            }
        }

        //ファイルルールを回す
        //ファイルルールを回す
        let pre_hit_count = 0
        for(let i=0; i<file_rule.length; i++){
            let hit_count = 0
            let condition_count = 0
            for(let key in file_rule[i]){
                if(file_rule[i][key] != '' && key != '計算式記号'){
                    condition_count++
                }
            }
            //一致しない場合は逆に
            if(file_rule[i].group1 && file_rule[i].group1 && style_selected1_name && file_rule[i].group1 && file_rule[i].group1!==style_selected1_name){
                continue
            }
            if(file_rule[i].group2 && file_rule[i].group2 && style_selected2_name && file_rule[i].group2 && file_rule[i].group2!==style_selected2_name){
                continue
            }

            if(file_rule[i].group1 && file_rule[i].group1 && style_selected1_name && file_rule[i].group1 && file_rule[i].group1===style_selected1_name){
                hit_count++
            }
            if(file_rule[i].group2 && file_rule[i].group2 && style_selected2_name &&file_rule[i].group2 && file_rule[i].group2===style_selected2_name){
                hit_count++
            }

            if(file_rule[i]['裾形状を選ぶ↓ヨコ使いレース生地のみ'] && file_rule[i]['裾形状を選ぶ↓ヨコ使いレース生地のみ']===context.state.step3_data.suso){
                hit_count++
            }
            if(file_rule[i]['絵羽'] && file_rule[i]['絵羽']===search_data['絵羽']){
                hit_count++
            }
            if(file_rule[i]['メカを選ぶ'] && file_rule[i]['メカを選ぶ']===context.state.step3_data.mecha){
                hit_count++
            }
            if(file_rule[i]['仕様を選択する'] && file_rule[i]['仕様を選択する']===context.state.step3_data.kurumi){
                hit_count++
            }
            if(file_rule[i]['ドレープ/レース'] && file_rule[i]['ドレープ/レース']===search_data['ドレープ/レース']){
                hit_count++
            }
            if(file_rule[i]['ヨコ使い'] && file_rule[i]['ヨコ使い']===search_data['ヨコ使い']){
                hit_count++
            }
            if(file_rule[i]['縫い区分'] && file_rule[i]['縫い区分']===search_data['縫い区分']){
                hit_count++
            }
            if(file_rule[i]['デザインビュー'] && file_rule[i]['デザインビュー']===search_data['デザインビュー']){
                hit_count++
            }
            if(file_rule[i]['FW付（filo縫製）'] && file_rule[i]['FW付（filo縫製）']===search_data['FW付（filo縫製）']){
                hit_count++
            }
            //console.log('atomaku i=' + i + ' style_selected1_name=' + file_rule[i].group1 + ' group2=' + file_rule[i].group2 + ' condition=' + condition_count + ' hit=' + hit_count+' pre_hit_count='+pre_hit_count)
            if(hit_count >= condition_count && hit_count>pre_hit_count){
                pre_hit_count = hit_count
                const file_name = item_number+file_rule[i]['計算式記号']+'.CSV'
                //console.log('atomaku_file_name', file_name)
                context.commit('updatePriceData', {name:'check_atomaku_file', value:file_name})
            }
        }
    },
    /**
     * CSVフォーマット
     */
    csvAtomakuFormating(context, payload){
        // 行単位で配列にする
        const lineArr = payload.split("\n")
        // 行と列の二次元配列にする
        let itemArr = []
        for (let i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split('","')
            for(let j=0; j < itemArr[i].length; j++){
                itemArr[i][j] = itemArr[i][j].replace(/\r/g , '')
                itemArr[i][j] = itemArr[i][j].replace(/"/g , '')
                itemArr[i][j] = itemArr[i][j].replace(/,/g , '')
            }
        }
        const group1 = context.state.step2_data.style_selected1_name
        const group2 = context.state.step2_data.style_selected2_name
        const style_selected1_name = context.state.step2_data.style_selected1_name
        const style_selected2_name = context.state.step2_data.style_selected2_name
        const search_data = context.state.search_data
        let group1_1 = ''
        if(context.state.step2_data.style_selected1_id !== ''){
            group1_1 = context.state.xlsx_data.style_data[context.state.step2_data.style_selected1_id].group1
        }
        let yokotsukai = ''
        if(context.state.xlsx_data.item_data && context.state.price_data.price_item_number){
            yokotsukai = context.state.xlsx_data.item_data['SH' + context.state.price_data.price_item_number]['ヨコ使い']
        }
        //const search_data = context.state.search_atomaku_data
        let price_data = {}
        let w,ws,we,wid,h,hs,he,hid
        let setting_index = {}


        for (let i = 0; i < itemArr.length - 1; i++) {
            if (itemArr[i][0] === '仕上り巾(cm)') {
                setting_index['フラット'] = {}
                setting_index['フラット']['片開き'] = i
                break
            }
        }

        for(let hida in setting_index){
            price_data[hida] = {}
            for(let open in setting_index[hida]){
                price_data[hida][open] =[]
                //各ヒダの巾情報位置
                let index = setting_index[hida][open]
                hid = 0
                for(let i=0; i<itemArr.length-1; i++){
                    if (!itemArr[i][0].match(/〜/) && !itemArr[i][0].match(/～/)) {
                        continue
                    }
                    if (itemArr[i][0].match(/〜/)) {
                        h = itemArr[i][0].split('〜')
                    }else if(itemArr[i][0].match(/～/)){
                        h = itemArr[i][0].split('～')
                    }
                    hs = h[0]
                    he = h[1]
                    hid++
                    wid = 0
                    for(let j=1; j < itemArr[i].length; j++){
                        if (!itemArr[index][j].match(/〜/) && !itemArr[index][j].match(/～/)) {
                            continue
                        }
                        if(itemArr[index][j].match(/〜/)){
                            w = itemArr[index][j].split('〜')
                        }else if(itemArr[index][j].match(/～/)){
                            w = itemArr[index][j].split('～')
                        }
                        ws = w[0]
                        we = w[1]
                        wid++
                        //価格表()の価格は高さが200cmまで
                        if (itemArr[i][j].match(/\(/)) {
                            itemArr[i][j] = itemArr[i][j].replace(/\(/g , '')
                            itemArr[i][j] = itemArr[i][j].replace(/\)/g , '')
                            if(style_selected2_name==='プレーンシェード' || style_selected2_name==='シャープシェード' || style_selected2_name==='ステップシェード'){
                                price_data[hida][open].push(
                                    {
                                        ws:ws,
                                        we:we,
                                        wid:wid,
                                        hs:hs,
                                        he:200,
                                        hid:hid,
                                        price:itemArr[i][j]
                                    }
                                )
                                continue
                            }
                        }
                        price_data[hida][open].push(
                            {
                                ws:ws,
                                we:we,
                                wid:wid,
                                hs:hs,
                                he:he,
                                hid:hid,
                                price:itemArr[i][j]
                            }
                        )
                    }
                }
            }
        }
        context.commit('updatePriceData', {name:'price_atomaku_csv', value:price_data})
        context.dispatch('priceAtomakuCalculation')
    },
    priceAtomakuCalculation(context){
        if(context.state.price_data.price_atomaku_file ===''){return false}
        if(context.state.price_data.price_atomaku_csv === '') {return false}
        //カーテン
        let price = 0
        let hida = context.state.step3_data.hida
        let open = context.state.step3_data.open
        let width_size = context.state.step3_data.width_size
        let height_size = context.state.step3_data.height_size
        let set_number = context.state.step4_data.set_number
        let style_selected1_name = context.state.step2_data.style_selected1_name
        let style_selected2_name = ''
        if(context.state.step3_data.atomaku_style){
            style_selected2_name = context.state.step3_data.atomaku_style
        }else{
            return false
        }

        if(hida === '' || open === '' || width_size === '' || height_size === ''){return false}
        if(hida === undefined){return false}
        if(!set_number){ set_number=0 }
        hida = hida.split('/')[0]
        hida = hida.replace(/約/g,'')
        if(hida==='1倍'){
            hida = 'フラット'
        }
        else if(hida==='2.3倍'){
            hida = '2倍ヒダ'
        }
        else{
            hida = hida+'ヒダ'
        }
        if(
            typeof(context.state.price_data.price_atomaku_csv[hida]) === 'undefined' ||
            typeof(context.state.price_data.price_atomaku_csv[hida][open])==='undefined'
        ){
            context.commit('updatePriceData', {name:'price_atomaku', value:0})
            return false;
        }
        const price_csv = context.state.price_data.price_atomaku_csv[hida][open]

        let wid = ''
        let hid = ''
        for(let i=0; i<price_csv.length; i++){
            if(style_selected2_name === 'プレーン小窓'){
                if(!context.state.step3_data.window_number){ return false }
                const window_num = context.state.step3_data.window_number
                wid = parseInt(window_num.replace(/台/g,''))
                if(parseInt(context.state.step3_data.width_size) >= 43){
                    wid+=3
                }
                if(
                    parseInt(price_csv[i].wid) === wid &&
                    parseInt(price_csv[i].hs) <= parseInt(height_size) && parseInt(price_csv[i].he) >= parseInt(height_size) &&
                    18 <= parseInt(width_size) && 65 >= parseInt(width_size)
                ){
                    price = parseInt(price_csv[i].price)
                    if(window_num == '1台'){
                        price -= 6000
                    }
                    else if(window_num == '2台'){
                        price -= 8000
                    }
                    else if(window_num == '3台'){
                        price -= 9000
                    }
                    price = price*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_atomaku', value:price})
                    return false
                }
            }
            else{
                if(parseInt(price_csv[i].ws) <= parseInt(width_size)-1 && parseInt(price_csv[i].we) >= parseInt(width_size)-1 &&
                    parseInt(price_csv[i].hs) <= parseInt(height_size)-1 && parseInt(price_csv[i].he) >= parseInt(height_size)-1 &&
                    context.state.step3_data.size_min_max[hida][open].width_min <= width_size-1 && context.state.step3_data.size_min_max[hida][open].width_max >= width_size-1 &&
                    context.state.step3_data.size_min_max[hida][open].height_min <= height_size-1 && context.state.step3_data.size_min_max[hida][open].height_max >= height_size-1
                ){
                    price = parseInt(price_csv[i].price)-6000
                    if(style_selected2_name === 'ステップシェード'){
                        price += 3000
                    }
                    price = price*parseInt(set_number)
                    context.commit('updatePriceData', {name:'price_atomaku', value:price})
                    wid = price_csv[i].wid
                    hid = price_csv[i].hid
                    return false
                    //break
                }
            }
        }
        context.commit('updatePriceData', {name:'price_atomaku', value:'製作不可のサイズです'})
        return false
    },
}
